import { Client } from "@stomp/stompjs";

import {
  API_KEY,
  SOCKET_CONNECT_URL,
  getAuthToken,
} from "../utils/common-utils";

import jwt_decode from "jwt-decode";
import _ from "lodash";

const triggers = {};
let client = null;

export const connect = async () => {
  if (null == client) {
    client = new Client({
      brokerURL: SOCKET_CONNECT_URL(),
      debug: function (str) {
        if (process.env.REACT_APP_ENV === "dev") {
          console.log("STOMP_DEBUG", str);
        }
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    client.onConnect = function (frame) {
      console.log("Socket connected successfully", frame);
      subscribe(getAuthToken());
    };

    client.onStompError = function (frame) {
      console.error("Broker reported error: " + frame.headers["message"]);
      console.error("Additional details: " + frame.body);
      refreshConnection().catch(console.error);
    };

    client.activate();
  }
};

export const subscribe = (authToken = null) => {
  if (null != client && client.connected) {
    if (authToken) {
      const { uid: identityId } = jwt_decode(authToken);

      client.subscribe(
        `/topic/identity/${identityId}`,
        (data) => {
          const { eventType, payload } = JSON.parse(data.body);

          if (triggers[eventType]) {
            triggers[eventType](payload);
          } else {
            console.log(
              "Could not find any listener for socket message",
              eventType,
              payload
            );
          }
        },
        prepareHeaders(authToken)
      );
    }
  }
};

const prepareHeaders = (authToken) => {
  const headers = { "x-api-key": API_KEY() };

  if (authToken) {
    headers["authorization"] = `Bearer ${authToken}`;
  }

  return headers;
};

export const sendMessage = (path, obj) => {
  if (null != client && client.connected) {
    client.publish({
      destination: `/socket/${path}`,
      body: JSON.stringify(obj),
      headers: prepareHeaders(getAuthToken()),
    });
  } else {
    console.error("!!! WebSocket not connected !!!!");
  }
};

export const registerSocketListener = (event, callback) => {
  if (_.isString(event) && _.isFunction(callback)) {
    triggers[event] = callback;
  }
};

export const refreshConnection = async () => {
  if (null != client) {
    console.log("Refreshing socket connection...");
    await client.deactivate();
    
    const authToken = getAuthToken();

    if (authToken) {
      console.log("Activating socket connection...");
      return client.activate();
    }
  }
};
